export enum DocumentAttribute {
  UNDEFINED = 'UNDEFINED',
  PERSONAL_IMAGE = 'PERSONAL_IMAGE',
  PERSONAL_IMAGES = 'PERSONAL_IMAGES',
  COMPANY_LOGO = 'COMPANY_LOGO',
  COMPANY_NDA = 'COMPANY_NDA',
  COMPANY_BOOKING_BACKGROUND = 'COMPANY_BOOKING_BACKGROUND',
  CONTEXT_CREDIT_POLICY = 'CONTEXT_CREDIT_POLICY',
  CONTEXT_EXAMPLE_TERM_SHEET = 'CONTEXT_EXAMPLE_TERM_SHEET',
  CONTEXT_EXAMPLE_CREDIT_AGREEMENT = 'CONTEXT_EXAMPLE_CREDIT_AGREEMENT',
  CONTEXT_MARKET_REPORT = 'CONTEXT_MARKET_REPORT',
  CONTEXT_SURVEY_RESULTS = 'CONTEXT_SURVEY_RESULTS',
  CONTEXT_OTHER = 'CONTEXT_OTHER',
  ITEM_MAIN_IMAGE = 'ITEM_MAIN_IMAGE',
  ITEM_EXTRA_IMAGE = 'ITEM_EXTRA_IMAGE',
  ITEM_ATTACHMENT = 'ITEM_ATTACHMENT',
  TEMPLATE_BASE_IMAGE = 'TEMPLATE_BASE_IMAGE',
  CREDIT_AGREEMENT = 'CREDIT_AGREEMENT',
  ALLO_GENERATED_DOCUMENT = 'ALLO_GENERATED_DOCUMENT',
  ALLO_ATTACHED_DOCUMENT = 'ALLO_ATTACHED_DOCUMENT',
  DEAL_CORE_PROCESSOR = 'DEAL_CORE_PROCESSOR',
  CONTACT_PROCESSOR = 'CONTACT_PROCESSOR',
  DEAL_PROCESSOR = 'DEAL_PROCESSOR',
}
